/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `RecipientListUser.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { RecipientListUser } from "./RecipientListUser";

import { RecipientList } from "./RecipientList";
import { User } from "./User";

export abstract class RecipientListUserModel {
    id: number;
    createdAt: Dayjs;
    recipientListId: number;
    updatedAt: Dayjs;
    userId: number;
    recipientList: RecipientList | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        createdAt: Dayjs,
        recipientListId: number,
        updatedAt: Dayjs,
        userId: number,
        recipientList: RecipientList | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.recipientListId = recipientListId;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.recipientList = recipientList;
        this.user = user;
    }

    static fromApiObject(json: any, timezone: string): RecipientListUser {
        const newObject = new RecipientListUser(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["recipient_list_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["recipient_list"] == null
                ? json["recipient_list"]
                : RecipientList.fromApiObject(json["recipient_list"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            recipient_list_id: this.recipientListId,
            updated_at: this.updatedAt,
            user_id: this.userId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): RecipientListUser {
        const clone = Object.create(this) as RecipientListUser;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
